import { ModelBase } from './base';

export enum SurveyRecommendation {
  Yes = 'yes',
  Maybe = 'maybe',
  No = 'no',
}

export enum SurveyFollowUp {
  Yes = 'yes',
  No = 'no',
}

export interface CreatorSurvey extends ModelBase {
  // Page 1 — context
  creatorName: string;
  popstoreUrl: string;
  creatorType: string;
  // Page 2 — AI agents
  aiAgents: string[];
  aiUsefulness: number; // 1..5
  aiIssues: string[];
  // Page 3 — experience
  frustration: string[];
  working: string[];
  // Page 4 — final
  recommendation: SurveyRecommendation;
  recommendationWhy: string;
  changeOne: string;
  followUp: SurveyFollowUp;
  email?: string;
  // meta — set server-side when available
  userId?: string;
}
